import React from 'react';

export const AuthLoadingScreen: React.FC = () => {
  
  return null;
};

export default AuthLoadingScreen;
